/* ==========================================================================
   search-drawer.js — Foundation Theme
   Predictive search: fires Shopify's /search/suggest.json after 3 chars.
   Renders product image, title, price and compare-at price.
   ========================================================================== */

(function () {
  'use strict';

  var drawer      = document.getElementById('search-drawer');
  if (!drawer) return;

  var panel       = drawer.querySelector('.search-drawer__panel');
  var inputEl     = drawer.querySelector('.search-drawer__input');
  var clearBtn    = drawer.querySelector('.search-drawer__clear');
  var resultsEl   = drawer.querySelector('.search-drawer__results');
  var openBtns    = document.querySelectorAll('.js-hdr-search');

  var moneyFmt    = drawer.getAttribute('data-money-format') || '${{amount}}';
  var hintText    = drawer.getAttribute('data-hint-text') || 'Type at least 3 characters to search\u2026';
  var debounce    = null;
  var activeQuery = '';
  var isOpen      = false;

  /* ── Open ────────────────────────────────────────────────────────── */
  function open() {
    if (isOpen) return;
    isOpen = true;
    drawer.setAttribute('aria-hidden', 'false');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    showHint();
    setTimeout(function () { if (inputEl) inputEl.focus(); }, 60);
  }

  /* ── Close — resets input and state ─────────────────────────────── */
  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.setAttribute('aria-hidden', 'true');
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    /* Reset everything for next open */
    clearTimeout(debounce);
    activeQuery = '';
    if (inputEl) inputEl.value = '';
    if (clearBtn) clearBtn.hidden = true;
  }

  /* ── Event wiring ────────────────────────────────────────────────── */

  /* Search icon toggle — stopPropagation so document click-outside
     handler doesn't immediately re-close on the same click event    */
  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen ? close() : open();
    });
  });

  /* × button — closes the drawer (input resets inside close()) */
  if (clearBtn) {
    clearBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });
  }

  /* Click outside the panel — close */
  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (panel && panel.contains(e.target)) return; /* click inside panel — ignore */
    close();
  });

  /* Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      e.preventDefault();
      close();
    }
  });

  /* Input change */
  if (inputEl) {
    inputEl.addEventListener('input', onInput);
  }

  /* ── Input handler ───────────────────────────────────────────────── */
  function onInput() {
    var q = (inputEl.value || '').trim();

    /* Show/hide the × button */
    if (clearBtn) clearBtn.hidden = q.length === 0;

    clearTimeout(debounce);

    if (q.length < 3) {
      activeQuery = '';
      showHint();
      return;
    }

    debounce = setTimeout(function () { fetchProducts(q); }, 280);
  }

  /* ── Shopify predictive search ───────────────────────────────────── */
  function fetchProducts(q) {
    if (q === activeQuery) return;
    activeQuery = q;
    showLoading();

    fetch(
      '/search/suggest.json' +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product' +
      '&resources[limit]=8'
    )
      .then(function (r) {
        if (!r.ok) throw new Error('Network error');
        return r.json();
      })
      .then(function (data) {
        if (q !== activeQuery) return; /* stale — discard */
        var products =
          (data.resources &&
           data.resources.results &&
           data.resources.results.products) || [];
        renderProducts(products, q);
      })
      .catch(function () {
        if (q !== activeQuery) return;
        showEmpty(q);
      });
  }

  /* ── Renderers ───────────────────────────────────────────────────── */
  function showHint() {
    resultsEl.innerHTML =
      '<p class="search-drawer__hint">' + esc(hintText) + '</p>';
  }

  function showLoading() {
    resultsEl.innerHTML =
      '<div class="search-drawer__loading"><div class="search-drawer__spinner"></div></div>';
  }

  function showEmpty(q) {
    resultsEl.innerHTML =
      '<p class="search-drawer__empty">No products found for <strong>&ldquo;' +
      esc(q) + '&rdquo;</strong></p>';
  }

  function renderProducts(products, q) {
    if (!products.length) { showEmpty(q); return; }

    var html = '<p class="search-drawer__label">Products</p>';
    html += '<ul class="search-results-list" role="list">';

    products.forEach(function (p) {
      /* Image — append Shopify CDN width for fast resize */
      var imgHtml = '';
      if (p.featured_image && p.featured_image.url) {
        var raw = p.featured_image.url;
        var src = raw + (raw.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        imgHtml = '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" width="60" height="60" loading="lazy">';
      }

      /* Prices */
      var priceNum   = parseFloat(p.price || '0');
      var compareNum = parseFloat(p.compare_at_price_min || '0');
      var hasSale    = compareNum > priceNum;
      var priceHtml  = '<span class="search-result__price' + (hasSale ? ' search-result__price--sale' : '') + '">' + fmt(p.price) + '</span>';
      var compareHtml = hasSale ? '<s class="search-result__compare">' + fmt(p.compare_at_price_min) + '</s>' : '';

      html +=
        '<li>' +
          '<a href="' + esc(p.url) + '" class="search-result">' +
            '<div class="search-result__img">' + imgHtml + '</div>' +
            '<div class="search-result__info">' +
              '<p class="search-result__title">' + esc(p.title) + '</p>' +
              '<div class="search-result__prices">' + priceHtml + compareHtml + '</div>' +
            '</div>' +
          '</a>' +
        '</li>';
    });

    html += '</ul>';
    html +=
      '<a href="/search?type=product&q=' + encodeURIComponent(q) + '" class="search-view-all">' +
        'View all results for &ldquo;' + esc(q) + '&rdquo;' +
        '<span class="search-view-all__arrow" aria-hidden="true">\u2192</span>' +
      '</a>';

    resultsEl.innerHTML = html;
  }

  /* ── Money formatter ─────────────────────────────────────────────── */
  function fmt(priceStr) {
    if (!priceStr) return '';
    var n = parseFloat(priceStr);
    if (isNaN(n)) return String(priceStr);
    var amount         = n.toFixed(2);
    var amountInt      = String(Math.floor(n));
    var amountComma    = amount.replace('.', ',');
    var amountIntComma = amountInt.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return moneyFmt
      .replace('{{amount}}',                                   amount)
      .replace('{{amount_no_decimals}}',                       amountInt)
      .replace('{{amount_with_comma_separator}}',              amountComma)
      .replace('{{amount_no_decimals_with_comma_separator}}',  amountIntComma);
  }

  /* ── HTML escape ─────────────────────────────────────────────────── */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

}());